import React from 'react';

const AutomoveisGrid = ({ children, className = '' }) => (
    <div
        className={`grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-5 lg:gap-6 ${className}`}
    >
        {children}
    </div>
);

export default AutomoveisGrid;
